import { ReactNode } from 'react'

import styles from './CockpitSectionHeader.module.scss'

interface ICockpitSectionHeaderProps {
  children: ReactNode
  actions?: ReactNode
  inline?: boolean
}

export const CockpitSectionHeader = ({
  children,
  actions,
  inline = false,
}: ICockpitSectionHeaderProps) => {
  const Root = inline ? 'span' : 'div'
  const Title = inline ? 'span' : 'h4'
  const Actions = inline ? 'span' : 'div'
  return (
    <Root className={inline ? `${styles.root} ${styles.inline}` : styles.root}>
      <Title className={styles.title}>{children}</Title>
      {actions && <Actions className={styles.actions}>{actions}</Actions>}
    </Root>
  )
}

CockpitSectionHeader.displayName = 'CockpitSectionHeader'
